/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsModeratorControllerDeleteTopUpsMutationResponse,
  TelegramProductsModeratorControllerDeleteTopUpsPathParams,
  TelegramProductsModeratorControllerDeleteTopUps401,
} from '../types/TelegramProductsModeratorControllerDeleteTopUps.ts';

function getTelegramProductsModeratorDeleteTopUpsUrl(
  id: TelegramProductsModeratorControllerDeleteTopUpsPathParams['id'],
) {
  const res = { method: 'DELETE', url: `/api/moderator/telegram/products/top-ups/${id}` as const };
  return res;
}

/**
 * {@link /api/moderator/telegram/products/top-ups/:id}
 */
export async function telegramProductsModeratorDeleteTopUps(
  id: TelegramProductsModeratorControllerDeleteTopUpsPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsModeratorControllerDeleteTopUpsMutationResponse,
    ResponseErrorConfig<TelegramProductsModeratorControllerDeleteTopUps401>,
    unknown
  >({ method: 'DELETE', url: getTelegramProductsModeratorDeleteTopUpsUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
